//PCIB忘记密码
<template>
  <div id="pcib_pwd" v-loading="loading" element-loading-text="发送中...">
    <div class="pwd_form">
        <ul>
            <li>忘记密码</li>
            <li class="input_area">
                <span>用户名：</span>
                <input type="text" v-model="user">
            </li>
            <li class="input_area">
                <span>邮箱名：</span>
                <input type="text" v-model="email">
            </li>
            <li class="check_code">
                <span>验证码：</span>
                <input type="text" v-model="i_code">
                <span class="code" @click="createCode()">{{g_code}}</span>
            </li>
            <li>
                <p>
                    请输入当前用户名或者用户邮箱以便找回密码，我们会发送重置密码链接到您的邮箱，请登录您的邮箱进行密码重置。
                </p>
            </li>
            <li class="sign_in">
                <el-button type="primary" :disabled="user === '' && email === '' || i_code === ''" @click="sendEmail()">发送邮件</el-button>

                <span>
                    <router-link :to="{ name: 'pcibLogin'}">返回登录</router-link>
                </span>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>
import { post } from '@/util/http';
export default {
    name: 'pcibPwd',
    created(){
        this.createCode();
    },
    watch: {
    },
    data () {
        return {
            user: '',
            email: '',
            loading: false,
            g_code: '',//生成的验证码
            i_code: '' //输入的验证码
        }
    },
    methods: {
        // 图片验证码
        createCode(){
            let code = "";
            let codeLength = 4;//验证码的长度
            let random = new Array(0,1,2,3,4,5,6,7,8,9,'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R',
                        'S','T','U','V','W','X','Y','Z');//随机数
            for(var i = 0; i < codeLength; i++) {
                //循环操作
                var index = Math.floor(Math.random()*36);//取得随机数的索引（0~35）
                code += random[index];//根据索引取得随机数加到code上
            }
            this.g_code = code;//把code值赋给验证码
        },
        sendEmail() {
            let self = this;
            if(self.i_code.toUpperCase() != self.g_code) {
                self.$notify({
                    type: "error",
                    message: "验证码错误，请重新输入！",
                    offset: 70
                });
                self.createCode();
                return false;
            }
            // let emailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/; //邮件格式正则
            // if(self.email.trim() != '' && !emailReg.test(self.email)) {
            //     self.$notify({
            //         type: "error",
            //         message: "邮箱格式错误！",
            //         offset: 70
            //     });
            //     self.createCode();
            //     return false;
            // }
            self.loading = true;
            post('user/password/reset/', {
                "username": self.user,
                "email": self.email
            }).then( res => {
                self.loading = false;
                self.createCode();
                self.$notify({
                    type: "success",
                    title: "发送成功！",
                    message: "请前往邮箱确认修改",
                    offset: 70
                });
                self.user = '';
                self.email = '';
            }, err => {
                self.loading = false;
                self.$notify({
                    type: "error",
                    message: err.data.email != undefined ? err.data.email[0] : err.data.username[0],
                    offset: 70
                });
                self.createCode();
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/mirrors/auths/PcibForgetPwd.vue